export const rangos = [0,1,2,3]
export const colores = ['#6c757d','#d90429','#8ac926','#0077b6']